/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPortfolioCompanies, PortfolioCompaniesFilters } from '../actions/portfolio-tracker';
import { InitiativeCompany } from '../types/initiative';

interface SliceState {
  data: InitiativeCompany[];
  id?: string;
  errorMessage: string;
  errored: boolean;
  loaded: boolean;
  loading: boolean;
}
const createState = (): SliceState => ({
  data: [],
  id: undefined,
  errorMessage: '',
  errored: false,
  loaded: false,
  loading: false,
});

const portfolioCompanySlice = createSlice({
  name: 'portfolioCompany',
  initialState: createState(),
  reducers: {
    load: (state, action: PayloadAction<string>) => ({ ...state, id: action.payload, loaded: false, loading: true }),
    reload: (state) => ({ ...state, loading: true }),
    loaded(state, action: PayloadAction<InitiativeCompany[]>) {
      return { ...state, data: action.payload, loaded: true, loading: false };
    },
    handleError(state, action: PayloadAction<string>) {
      return {
        ...state,
        loaded: true,
        loading: false,
        errored: true,
        errorMessage: action.payload,
      };
    },
  },
});

const { load, reload, loaded, handleError } = portfolioCompanySlice.actions;

export const loadPortfolioCompanies = (portfolioId: string) => (dispatch: any, getState: () => any) => {
  const sliceState: SliceState = getState()[portfolioCompanySlice.name];

  if (sliceState.loaded && sliceState.id === portfolioId) {
    return;
  }

  dispatch(load(portfolioId));

  getPortfolioCompanies(portfolioId)
    .then((data) => {
      dispatch(loaded(data));
    })
    .catch((e) => handleError(e));
};

export const reloadPortfolioCompanies =
  (portfolioId: string, flagReload: boolean = false, filters?: PortfolioCompaniesFilters) =>
  (dispatch: any) => {
    if (flagReload) {
      dispatch(reload());
    }

    getPortfolioCompanies(portfolioId, true, filters)
      .then((data) => {
        dispatch(loaded(data));
      })
      .catch((e) => handleError(e));
  };

export default portfolioCompanySlice.reducer;
